import React, { useState, useEffect, useRef } from 'react'
import { Form, notification, Col, Row, Button, Select, Tooltip, Icon } from 'antd'
import { useDispatch } from 'react-redux'
import {
  adminRightUser,
  filterOption,
  InputBox
} from '../../components/_utils/appUtils'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import { TableComp } from 'sz-react-utils-lite'
import AddHeadCategory from './headCategoryDrawer'
import { addUniversityHeadFxn, getAllHeadCategoryFxn, listAllUniversityHeadFxn } from './actions'
import { listAllUniversities } from '../university/actions/university'
import { getUser } from '../users/actions/user'

const AddUniversityHead = (props) => {
  const { form: { getFieldDecorator, getFieldValue } } = props
  const tableAppRef = useRef()

  const dispatch = useDispatch()
  let [totalApplication, setTotalApplication] = useState(0)
  let [headTypeArr, setHeadTypeArr] = useState([])
  let [headTypeId, setHeadTypeId] = useState('')
  let [universityName, setUniversityName] = useState('')
  let [universityCountry, setUniversityCountry] = useState('')
  let [headTypeName, setHeadTypeName] = useState('')
  let [addHeadCategoryDrawer, setAddHeadCategoryDrawer] = useState({ visible: false })
  let [allUniversity, setAllUniversity] = useState([])
  let [universityId, setUniversityId] = useState('')
  let [userData, setUserData] = useState({})
  let [autoGeneratedName, setAutoGeneratedName] = useState('')

  useEffect(() => {
    if (universityName && headTypeName) {
      setAutoGeneratedName(`${universityName}-${headTypeName}`)
    }
  }, [universityName, headTypeName])

  const { Option } = Select

  const getUserData = async () => {
    let Data = JSON.parse(localStorage.getItem('user'))
    let resp = await dispatch(getUser(Data._id))
    setUserData(resp)
  }


  const loadAllUniversity = async () => {
    let { data } = await dispatch(listAllUniversities({
      results: 1000,
      sortField: 'universityName',
      sortOrder: 'ascend',
      universityCountry: userData && userData.countryId && userData.countryId._id ? userData.countryId._id : ''
    }))
    setAllUniversity(data)
  }

  const reloadTable = () => {
    tableAppRef.current.reload()
  }
  const showHeadCategoryDrawer = () => {
    setAddHeadCategoryDrawer(
      {
        visible: true
      }
    )
  }
  const hideHeadCategoryDrawer = () => {
    setAddHeadCategoryDrawer(
      {
        visible: false
      }
    )
    fetchHeadCategory()
  }

  let apiRequest = params => {
    return new Promise(async resolve => {
      if (!params.results) {
        params.results = 50
        params.count = 50
      }
      if (userData && userData.userType == 'branchManager' && userData.countryId && userData.countryId._id) {
        params.countryId = userData.countryId._id
        let resp = await dispatch(listAllUniversityHeadFxn({
          ...params
        }))
        setTotalApplication(resp.total)
        resolve(resp)
      } else if (userData.userType == 'admin') {
        let resp = await dispatch(listAllUniversityHeadFxn({
          ...params
        }))
        setTotalApplication(resp.total)
        resolve(resp)
      } else {
        resolve([])
      }
    })
  }

  let fetchHeadCategory = () => {
    return new Promise(async () => {
      let resp = await dispatch(getAllHeadCategoryFxn())
      setHeadTypeArr(resp.data)
    })
  }

  useEffect(() => {
    fetchHeadCategory()
    getUserData()
  }, [])

  useEffect(() => {
    loadAllUniversity()
    tableAppRef.current.reload()
  }, [userData && userData.countryId && userData.countryId._id])

  const columns = [
    {
      key: '_id',
      title: '#',
      dataIndex: '_id',
      width: 50,
      render: (item, record, index) => {
        return (
          <>
            {(index + 1)}
          </>
        )
      }
    },

    {
      title: 'University',
      key: 'universityId',
      dataIndex: 'universityId',
      width: 150,
      render: (item, record) => {
        return (
          <div>
            <label>{item && item.universityName ? item.universityName : '--'}</label>
          </div>
        )
      }
    },
    {
      title: 'Head Type',
      key: 'headCategoryId',
      dataIndex: 'headCategoryId',
      width: 150,
      render: (item, record) => {
        return (
          <div>
            <label>{item && item.type ? item.type : '--'}</label>
          </div>
        )
      }
    },
    //label label-tag-new label-sm
    {
      title: 'Head Name',
      key: 'headName',
      dataIndex: 'headName',
      width: 150,
      render: (item, record) => {
        return (
          <div>
            <label
              className={'label label-tag-new label-sm'}>{item ? item : '--'}</label>
          </div>
        )
      }

    },
    {
      title: 'Actions',
      width: 150,
      dataIndex: 'amount',
      key: 'debit',
      render: (item, record) => {
        let { transactionType } = record
        return (
          transactionType == 'Debit' ? <label className={'label label-danger label-sm'}>
            Rs. {item}
          </label> : null
        )
      }
    }
  ]

  const handleSubmit = async (e) => {
    const { form } = props
    e.preventDefault()
    try {
      const valData = await form.validateFields()
      if (!universityId) {
        notification.warning({ message: 'Please Choose University' })
        return
      }
      if (!headTypeId) {
        notification.warning({ message: 'Please Choose head type' })
        return
      }
      valData.universityId = universityId
      valData.headCategoryId = headTypeId.key
      valData.universityName = universityName
      valData.countryId = universityCountry
      valData.headTypeName = headTypeName
      valData.headName = autoGeneratedName
      const data = await dispatch(addUniversityHeadFxn(valData))
      if (data && data.success) {
        form.resetFields()
        setUniversityName('')
        setHeadTypeName('')
        setUniversityId('')
        setHeadTypeId('')
        setAutoGeneratedName('')
        reloadTable()
      }
    } catch (err) {
      notification.warning({
        message: 'Fill All Required Fields'
      })
    }
  }

// add these two new states


  const inputTypes = {
    fields: [
      {
        label: 'University',
        required: true,
        customField: (
          <InputBox title='* University' className='rowFlex' customStyle={{ marginTop: 10 }}>
            <Select
              placeholder={'university'}
              filterOption={filterOption}
              allowClear={true}
              showSearch={true}
              value={universityId || undefined}
              onChange={(value) => {
                setUniversityId(value)

                // Find and set the university name
                const uni = allUniversity.length && allUniversity.find(u => u._id === value)
                setUniversityName(uni ? uni.universityName : '')
                setUniversityCountry(uni ? uni.universityCountry : '')
              }}
            >
              {allUniversity && allUniversity.length
                ? allUniversity.map((item) => (
                  <Option key={item._id} value={item._id}>
                    {item.universityName}
                  </Option>
                ))
                : null}
            </Select>
          </InputBox>
        )
      },
      {
        label: 'Head Type',
        required: true,
        customField: (
          <InputBox title='* Head Type' className='rowFlex' customStyle={{ marginTop: 10 }}>
            <Select
              labelInValue
              value={headTypeId}
              placeholder='Select Head Type'
              allowClear={true}
              filterOption={false}
              showSearch={true}
              onChange={(val) => {
                setHeadTypeId(val)
                setHeadTypeName(val && val.label || '')
              }}
            >
              {headTypeArr && headTypeArr.length
                ? headTypeArr.map(d => (
                  <Option key={d._id} value={d._id}>
                    {d.type}
                  </Option>
                ))
                : null}
            </Select>
            <Tooltip title={'Add Head Type'}>
              <a onClick={() => showHeadCategoryDrawer()} className={'btn btn-default ml10'}>
                <Icon type={'plus'} style={{ marginRight: 0 }} />
              </a>
            </Tooltip>
          </InputBox>
        )
      },
      {
        label: 'Generated Head Name',
        required: true,
        customField: (
          <>
            {universityName && headTypeName ? (
              <InputBox title='* Head Name' className='rowFlex' customStyle={{ marginTop: 10 }}>
                <input
                  type='text'
                  className='form-control'
                  value={autoGeneratedName}
                  onChange={(e) => setAutoGeneratedName(e.target.value)}
                />
              </InputBox>
            ) : null}
          </>
        )
      }

    ]
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  return (
    <>
      <div className='row mt-4'>
        <div className='col-lg-4'>
          <div className='form-box'>
            <div className='d-flex align-items-center mb-3 heading-form'>
              <h5>Add University Head</h5>
            </div>
            <div className='card unizportal'>
              <Form>
                <Row gutter={24}>
                  {inputTypes.fields.map((item, key) => {
                    return (
                      <>
                        {item.customField ?
                          <Col span={24}>
                            {item.customField}
                          </Col> :
                          <Col span={24} key={key}>
                            <GetEachFormFields
                              item={{ ...item, rules: item.rules }}
                              getFieldDecorator={getFieldDecorator}
                              formItemLayout={formItemLayout} />
                          </Col>}
                      </>
                    )
                  })}
                </Row>
                <button className='btn' type='submit' onClick={handleSubmit}>Save</button>
              </Form>
            </div>
          </div>
        </div>
        <div className='col-lg-8'>
          <React.Fragment>
            <div className='d-flex align-items-center mb-3 heading-form'>
              <h5 className={'w-50'}>University Head List (Total - {totalApplication})</h5>
              <div className='sort-box-table mark-btn alignRight w-50'>
              </div>

            </div>
            <div className='card'>
              <div className='card-body table-responsive'>
                <TableComp
                  columns={columns}
                  rowKey={(item, index) => {
                    return index
                  }}
                  apiRequest={apiRequest}
                  pagination={{
                    position: 'top',
                    pageSizeOptions: ['50', '100', '150', '200'],
                    defaultPageSize: 50
                  }}
                  ref={tableAppRef}
                />
              </div>
            </div>
          </React.Fragment>
        </div>
      </div>
      {addHeadCategoryDrawer.visible &&
      <AddHeadCategory
        visible={addHeadCategoryDrawer.visible}
        onClose={() => {
          hideHeadCategoryDrawer()
        }}
      />
      }
    </>
  )
}


export default Form.create()(AddUniversityHead)


//NewCommissionFlow
